var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "site-link",
    {
      class: [
        `card margin-bottom-0 with-top-tag ${_vm.cardColor}`,
        { " dark": _vm.isDarkTheme },
      ],
      staticStyle: { height: "100%" },
      attrs: {
        to: _vm.$search({
          iconPacks: [_vm.hyphenatedFamilyName(_vm.familyName)],
          styles: _vm.styleName,
        }),
      },
      nativeOn: {
        click: function ($event) {
          return _vm.$posthog.capture(_vm.posthogCaptureName, {
            family: _vm.familyName,
            style: _vm.styleName,
          })
        },
      },
    },
    [
      _vm.isNew
        ? _c("span", { staticClass: "tag top secondary" }, [
            _vm._v("\n    New\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header padding-bottom-sm",
          staticStyle: {
            "clip-path": "polygon(0 0, 100% 0, 100% 100%, 0 80%)",
          },
        },
        [
          _c("icon-grid", {
            attrs: {
              "full-style-name": _vm.fullStyleName,
              "icons-row-one": _vm.cardIconsRowOne,
              "icons-row-two": _vm.cardIconsRowTwo,
              "icons-row-three": _vm.cardIconsRowThree,
              "is-vertical": true,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "section text-left margin-top-0 padding-top-0 padding-bottom-2xs",
        },
        [
          _c("card-copy", {
            attrs: {
              "card-color": _vm.cardColor,
              "family-name": _vm.familyName,
              "style-description": _vm.styleDescription,
              "style-name": _vm.styleName,
              "is-dark-theme": _vm.isDarkTheme,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }